import kart_1 from "../assets/karton_1.mp4";
import kart_2 from "../assets/kart_2.png";
import kart_3 from "../assets/kart_3.png";
import kart_4 from "../assets/kart_4.png";

import E_Ticaret from "../assets/sektorler_logo/e_ticaret.svg";
import Edustriyel from "../assets/sektorler_logo/endustriyel.svg";
import Perakende from "../assets/sektorler_logo/perakende.svg";
import Kozmetik from "../assets/sektorler_logo/kozmetik.svg";
import Otomotiv from "../assets/sektorler_logo/otomotiv.svg";
import Yasmeyvesebze from "../assets/sektorler_logo/e_ticaret.svg";
import FMCG from "../assets/sektorler_logo/ilac.svg";
import Takeaway from "../assets/sektorler_logo/kozmetik.svg";


import E_Ticaret_b from "../assets/sektorler_logo/e_ticaret_b.svg";
import Edustriyel_b from "../assets/sektorler_logo/endustriyel_b.svg";
import Perakende_b from "../assets/sektorler_logo/perakende_b.svg";
import Kozmetik_b from "../assets/sektorler_logo/kozmetik_b.svg";
import Yasmeyvesebze_b from "../assets/sektorler_logo/e_ticaret_b.svg";
import FMCG_b from "../assets/sektorler_logo/ilac_b.svg";
import Otomotiv_b from "../assets/sektorler_logo/otomotiv_b.svg";
import Takeaway_b from "../assets/sektorler_logo/kozmetik_b.svg";


import teknik_kutu from "../assets/teknik_kutu.png";
import acik_kutu from "../assets/acik_kutu.png";

import Yonetim_image from "../assets/yonetim.png";
import Discover_1 from "../assets/Discover_1.svg";
import Discover_2 from "../assets/Discover_2.svg";

import Kutu_1 from "../assets/Urunler/kutu_1.jpg";
import Kutu_2 from "../assets/Urunler/kutu_2.jpg";
import Kutu_3 from "../assets/Urunler/kutu_3.jpg";
import Kutu_4 from "../assets/Urunler/kutu_4.jpg";
import Kutu_5 from "../assets/Urunler/kutu_5.jpg";
import Kutu_6 from "../assets/Urunler/kutu_6.jpg";
import Kutu_7 from "../assets/Urunler/kutu_7.jpg";
import Kutu_8 from "../assets/Urunler/kutu_8.jpg";

import Makina_Data from "../assets/Makina_Data.png";
import Mabsan_Way_image from "../assets/image_1.svg";
import Mukavva_Data from "../assets/Mukavva_Data.png";

const SektorItems = [
  {
    name: "Ecommerce",
    image: E_Ticaret,
    image_b: E_Ticaret_b,
    way: "eticaret",
    video: "eticaret.mp4",
    header: "E-Commerce Products",
    info:
      "Speed and trust are key in the e-commerce industry, where sales must continue 24/7 regardless of the conditions. With our e-commerce expertise, you can trust us to provide reliable, innovative and sustainable solutions for your online business and your customers.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Industrial",
    image: Edustriyel,
    image_b: Edustriyel_b,
    way: "endustriyel",
    video: "endustriyel.mp4",
    header: "Industrial Products",
    info:
      "In the industrial market, product safety is paramount. From heavy and bulky products to hazardous materials, it is critical to provide flexible options that can withstand the logistical challenges of industrial products. That's why our corrugated solutions undergo extensive testing to ensure durability and reliability during transport.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Retail",
    image: Perakende,
    image_b: Perakende_b,
    way: "perakende",
    video: "perakende.mp4",
    header: "Retail Products",
    info:
      "The power of packaging in the purchasing decisions of today's consumers is indisputable. Not only design, but also packaging that is safe and takes into account user behaviour makes a big difference in sales. You can rely on our experience with many national and international retail brands.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Cosmetics",
    image: Kozmetik,
    image_b: Kozmetik_b,
    way: "kozmetik",
    video: "kozmetik.mp4",
    header: "Cosmetics Products",
    info:
      "In the highly competitive cosmetics market, it is becoming difficult for brands to stay in the minds of existing and new consumers. This leads to the need for continuous innovation in visual and texture. As a reliable and creative business partner, we are at your side to help your products stand out. ",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Fruit and Vegetable",
    image: Yasmeyvesebze,
    image_b: Yasmeyvesebze_b,
    way: "yasmeyvesebze",
    video: "yasmeyvesebze.mp4",
    header: "Fruit and Vegetable Products",
    info:
      "With high volumes of fresh fruit and vegetable products requiring protection against spoilage throughout the supply chain, it is essential to utilise strong and reliable packaging solutions. Our carefully engineered paper-based solutions for each product type are designed, tested and manufactured to protect food products while fulfilling our sustainability promise.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "FMCG",
    image: FMCG,
    image_b: FMCG_b,
    way: "FMCG",
    video: "FMCG.mp4",
    header: "FMCG Products",
    info:
      "FMCG packaging and displays are critical tools for influencing consumers at the moment of decision.We utilise our extensive FMCG experience to make your products stand out and maintain efficiency in the supply chain. ",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Automotive",
    image: Otomotiv,
    image_b: Otomotiv_b,
    way: "otomotiv",
    video: "otomotiv.mp4",
    header: "Automotive Products",
    info:
      "Whether we are packing small or large, light or heavy components, we use proven scientific methods to deliver fit-for-purpose and sustainable packaging solutions. Our range of products, including friction and corrosion resistant packs, are designed to meet the physical requirements of your supply chain.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
  {
    name: "Take-Away",
    image: Takeaway,
    image_b: Takeaway_b,
    way: "takeaway",
    video: "takeaway.mp4",
    header: "Take-Away Products",
    info:
      "From fast-food chains to fine dining restaurants, those serving in today's food and beverage industry care about their environmental impact and prefer paper-based packages instead of plastic. You can rely on us to guarantee the satisfaction of your customers in your take-away or takeaway services.",
    teknik_kutu: teknik_kutu,
    acik_kutu: acik_kutu,
    data_1: "30",
    data_2: "30",
    data_3: "30",
    data_4: "30",
    data_5: "30",
  },
];

const UretimData = [
  {
    id: "1",
    header1: '"Our first step for a sustainable world is recycling."',
    detail:
      "We reintroduce scrap paper to the world through an environmentally friendly recycling process.",
    header2: "Recycling",
    photoLink: kart_1,
  },
  {
    id: "2",
    header1: "We rely on technology to protect your products.",
    detail:
      "The recycled materials are converted into robust and durable ream paper by high-tech machines.",
    header2: "High Technology",
    photoLink: kart_2,
  },
  {
    id: "3",
    header1: "With 36 years of experience, we do what we know best.",
    detail:
      "We process the paper reels in corrugated cardboard machines and give them a corrugated form. We proceed to the production of flat sheet cardboard by combining flat paper and corrugated paper.",
    header2: "Corrugated Cardboard",
    photoLink: kart_3,
  },
  {
    id: "4",
    header1: "We design solutions that make a difference for your brand reputation.",
    detail:
      "We transform corrugated cardboard sheets into parcels and boxes, which are the final product, by precise cutting, printing and special gluing processes.",
    header2: "Brand Specific Solutions",
    photoLink: kart_4,
  },
];

const YolculugumuzData = [
  {
    year1: "19",
    year2: "88",
    title: "Organisation",
    text: "Our journey started in Istanbul in 1988.",
  },
  {
    year1: "19",
    year2: "91",
    title: "First Automation Investment",
    text:
      "We took our first step towards automation by investing in slotter machines, which are automatic box machines.",
  },
  {
    year1: "19",
    year2: "94",
    title: "Storage Investments",
    text:
      "We established and operated additional storage areas in 4 different locations by not fitting into our existing area.",
  },
  {
    year1: "19",
    year2: "98",
    title: "Our Export Steps",
    text:
      "We moved to our new location and increased our production capacity; we started exporting to Azerbaijan and Turkic Republics for the first time.",
  },
  {
    year1: "19",
    year2: "99",
    title: "Corrugated Cardboard Production",
    text:
      "We invested in our first corrugated cardboard machine and became one of the few companies in Turkey producing corrugated cardboard.",
  },
  {
    year1: "20",
    year2: "04",
    title: "Capacity Investments",
    text:
      "With the expansion of our customer portfolio, we doubled our production capacity by purchasing new inline automatic box machines.",
  },
  {
    year1: "20",
    year2: "07",
    title: "Product Portfolio Expands",
    text:
      "In order to adapt to changing habits and to lead the sector, we increased our product range with our cutting machine investments.",
  },
  {
    year1: "20",
    year2: "11",
    title: "Corrugated Cardboard Line Expands",
    text:
      "With our new line, we have become a facility that produces all product types as cardboard and parcel box by realising E wave and EB wave productions.",
  },
  {
    year1: "20",
    year2: "16",
    title: "Offset Products",
    text:
      "We expanded our product range with offset products and switched to printing.",
  },
  {
    year1: "20",
    year2: "19",
    title: "New Factory Investment",
    text:
      "We moved to our new factory for more trust, design and innovation.",
  },
  {
    year1: "20",
    year2: "24",
    title: "A New Mabsan",
    text:
      "With the strength of our 36 years of experience and the courage we take from our dreams for the future, we continue our journey with our renewed brand.",
  },
];

const Paragraflar = {
  hakkimizda:
    "Since 1988, we are proud to be the trusted partner of national and international brands in packaging solutions. We have earned this trust with our courage for continuous development, our commitment to global production standards, our technology investments and our equal care approach to every customer. \n\n Thanks to our wide customer portfolio and quality product range, we have become one of the leading companies in our sector. Without compromising our principles, we strengthen our position among the most respected companies in our sector thanks to our steady growth. \n\n",
  misyon:
    "We add value to the reputation and business processes of the brands we work with with quality products, innovative designs and long-term trust-based customer relationships. ",
  vizyon:
    "To be the most reliable business partner in every sector from retail to automotive as one of the leading manufacturers in the sustainable transformation of the corrugated cardboard industry. ",
};

const YasalData = {
  yasal_bildiri:
    "Since 1988, we have been acting in accordance with all relevant legal regulations and sectoral standards in our services to national and international customers. In this context, we provide information about our legal notices and policies below. \n\nCopyright and Intellectual Property Rights \n\nAll content, images, texts, logos and other materials on this website belong to Mabsan Oluklu Mukavva Kutu Sanayi A.Ş. unless otherwise stated and all copyrights are reserved. Copying, distributing, reproducing or using the contents for commercial purposes is subject to the written permission of Mabsan. \n\nPrivacy Policy \n\n\nThe privacy of our users who visit our website is our priority. Personal data are processed within the scope of the Law No. 6698 on the Protection of Personal Data (‘KVKK’) and you can find detailed information on our Privacy Policy page. \n\nTerms of Use \n\nBy using this website, you agree to our terms of use. The information and services offered on the website are subject to change without prior notice. Users are obliged to act in accordance with the Turkish Penal Code and other relevant legislation during the use of the site. \n\nDisclaimer \n\n\nAlthough maximum effort is made to ensure that the information contained in this website is up-to-date and accurate, Mabsan cannot be held responsible for the accuracy, completeness of the content or any damage that may arise as a result of use. The decisions and actions taken by the users are entirely their own responsibility. \n\nContact \n\n\nYou can contact us for any questions, comments or feedback: \n\nTelephone: +90 (0216) 484 18 00 \nEmail: info@mabsan.com \nAddress: Büyükbakkalköy, Kaşif Sk. No: 15, 34858 Maltepe / İstanbul, Turkey \n\nAs Mabsan Oluklu Mukavva Kutu Sanayi A.Ş., our main priority is to maintain our reliable service understanding and to act in accordance with legal regulations. \n\n",
 

};
const GizlilikData = {
  gizlilik_bildiri:"Since 1988, we have been acting in accordance with all relevant legal regulations and sectoral standards in our services to national and international customers. In this context, we provide information about our legal notices and policies below. \n\nCopyright and Intellectual Property Rights \n\nAll content, images, texts, logos and other materials on this website belong to Mabsan Oluklu Mukavva Kutu Sanayi A.Ş. unless otherwise stated and all copyrights are reserved. Copying, distributing, reproducing or using the contents for commercial purposes is subject to the written permission of Mabsan. \n\nPrivacy Policy \n\n\nThe privacy of our users who visit our website is our priority. Personal data are processed within the scope of the Law No. 6698 on the Protection of Personal Data (‘KVKK’) and you can find detailed information on our Privacy Policy page. \n\nTerms of Use \n\nBy using this website, you agree to our terms of use. The information and services offered on the website are subject to change without prior notice. Users are obliged to act in accordance with the Turkish Penal Code and other relevant legislation during the use of the site. \n\nDisclaimer \n\n\nAlthough maximum effort is made to ensure that the information contained in this website is up-to-date and accurate, Mabsan cannot be held responsible for the accuracy, completeness of the content or any damage that may arise as a result of use. The decisions and actions taken by the users are entirely their own responsibility. \n\nContact \n\n\nYou can contact us for any questions, comments or feedback: \n\nTelephone: +90 (0216) 484 18 00 \nEmail: info@mabsan.com \nAddress: Büyükbakkalköy, Kaşif Sk. No: 15, 34858 Maltepe / İstanbul, Turkey \n\nAs Mabsan Oluklu Mukavva Kutu Sanayi A.Ş., our main priority is to maintain our reliable service understanding and to act in accordance with legal regulations. \n\n"

}
const HizmetPolitikakData = {
  hizmet_bildiri:"Since 1988, we have been acting in accordance with all relevant legal regulations and sectoral standards in our services to national and international customers. In this context, we provide information about our legal notices and policies below. \n\nCopyright and Intellectual Property Rights \n\nAll content, images, texts, logos and other materials on this website belong to Mabsan Oluklu Mukavva Kutu Sanayi A.Ş. unless otherwise stated and all copyrights are reserved. Copying, distributing, reproducing or using the contents for commercial purposes is subject to the written permission of Mabsan. \n\nPrivacy Policy \n\n\nThe privacy of our users who visit our website is our priority. Personal data are processed within the scope of the Law No. 6698 on the Protection of Personal Data (‘KVKK’) and you can find detailed information on our Privacy Policy page. \n\nTerms of Use \n\nBy using this website, you agree to our terms of use. The information and services offered on the website are subject to change without prior notice. Users are obliged to act in accordance with the Turkish Penal Code and other relevant legislation during the use of the site. \n\nDisclaimer \n\n\nAlthough maximum effort is made to ensure that the information contained in this website is up-to-date and accurate, Mabsan cannot be held responsible for the accuracy, completeness of the content or any damage that may arise as a result of use. The decisions and actions taken by the users are entirely their own responsibility. \n\nContact \n\n\nYou can contact us for any questions, comments or feedback: \n\nTelephone: +90 (0216) 484 18 00 \nEmail: info@mabsan.com \nAddress: Büyükbakkalköy, Kaşif Sk. No: 15, 34858 Maltepe / İstanbul, Turkey \n\nAs Mabsan Oluklu Mukavva Kutu Sanayi A.Ş., our main priority is to maintain our reliable service understanding and to act in accordance with legal regulations. \n\n"

}

const CerezPolitikakData = {
  cezer_bildiri:"As Mabsan Oluklu Mukavva Kutu Sanayi A.Ş., we use cookies to improve the experience of users visiting our website and to optimise our services. This Cookie Policy explains what types of cookies we use and how to manage them. \n\nWhat is a Cookie? \n\nCookies are small text files placed on your device when you visit our website. These files help us remember your user preferences and improve site performance. \n\nWhat Cookies Do We Use? \n\n\nMandatory Cookies: Necessary for our website to fulfil its basic functions. \nPerformance Cookies: Used to analyse the performance and functionality of our website. \Targeting and Advertising Cookies: Provides customised content and advertisements based on user preferences. \n\nCookies Management \n\n\nYou do not have to accept cookies. You can disable or delete cookies by changing your browser settings. However, some features of our website may work limited if cookies are disabled.  \n\nThird Party Cookies \n\n\nOur website may also use cookies from third party service providers. These cookies are subject to the privacy policies of the relevant third party. \n\nPrivacy and Security \n\nThe protection of your personal information is our top priority. Data collected through cookies is processed in accordance with our Privacy Policy. \n\nContact \n\n\nYou can contact us for your questions about our cookie policy: \nTelephone: +90 (0216) 484 18 00 \nEmail: info@mabsan.com \n\n\nBy using our website, you agree to this Cookie Policy."

}

const Cards = {
  value1: "Development Inside Mabsan",
  value2: `The importance of development at every stage from production to sales, from design to customer relations
  we believe. The journey you start here is not a fixed path, it's always new paths.
  and you come across opportunities.`,
  value3: Discover_1,
  value4: "There is Expertise in Mabsan",
  value5: `At Mabsan, we do our job with care and expertise. In all our departments, we work with the best
  we work with those who do, we have infinite trust in our teams. You are a professional here
  you can have a say in the field.`,
  value6: Discover_2,
};

const YonetimData = [
  {
    id: "1",
    Name: "Ayla Haktan",
    Position: "Manager",
    photoLink: Yonetim_image,
  },
  {
    id: "2",
    Name: "Ali Kara",
    Position: "Accounting Manager",
    photoLink: Yonetim_image,
  },
  {
    id: "3",
    Name: "Fatma Demir",
    Position: "Human Resources Manager",
    photoLink: Yonetim_image,
  },
  {
    id: "4",
    Name: "Mehmet Yılmaz",
    Position: "Technology Manager",
    photoLink: Yonetim_image,
  },
  {
    id: "5",
    Name: "Zeynep Güler",
    Position: "Marketing Manager",
    photoLink: Yonetim_image,
  },
  {
    id: "6",
    Name: "Hasan Karadeniz",
    Position: "Sales Manager",
    photoLink: Yonetim_image,
  },
];

const SurdurData = [
  {
    id: 1,
    file: "belge 1",
    file_address: "belge - Kopya (1).pdf",
  },
  {
    id: 2,
    file: "belge 2",
    file_address: "belge - Kopya (2).pdf",
  },
  {
    id: 3,
    file: "belge 3",
    file_address: "belge - Kopya (3).pdf",
  },
  {
    id: 4,
    file: "belge 4",
    file_address: "belge - Kopya (4).pdf",
  },
  {
    id: 5,
    file: "belge 5",
    file_address: "belge - Kopya (5).pdf",
  },
  {
    id: 6,
    file: "belge 6",
    file_address: "belge - Kopya (6).pdf",
  },
  {
    id: 7,
    file: "belge 7",
    file_address: "belge - Kopya (7).pdf",
  },
  {
    id: 8,
    file: "belge 8",
    file_address: "belge - Kopya (8).pdf",
  },
  {
    id: 9,
    file: "belge 9",
    file_address: "belge - Kopya (9).pdf",
  },
  {
    id: 10,
    file: "belge 10",
    file_address: "belge - Kopya (10).pdf",
  },
  {
    id: 11,
    file: "belge 11",
    file_address: "belge - Kopya (11).pdf",
  },
  {
    id: 12,
    file: "belge 12",
    file_address: "belge - Kopya (12).pdf",
  },
  {
    id: 13,
    file: "belge 13",
    file_address: "belge - Kopya (13).pdf",
  },
  {
    id: 14,
    file: "belge 14",
    file_address: "belge - Kopya (14).pdf",
  },
  {
    id: 15,
    file: "belge 15",
    file_address: "belge - Kopya (15).pdf",
  },
  {
    id: 16,
    file: "belge 16",
    file_address: "belge - Kopya (16).pdf",
  },
  {
    id: 17,
    file: "belge 17",
    file_address: "belge - Kopya (17).pdf",
  },
  {
    id: 18,
    file: "belge 18",
    file_address: "belge - Kopya (18).pdf",
  },
  {
    id: 19,
    file: "belge 19",
    file_address: "belge - Kopya (19).pdf",
  },
];

const UrunData = [
  {
    id: 1,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 2,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_2",
  },
  {
    id: 3,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_3",
  },
  {
    id: 4,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 5,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 6,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 7,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 8,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 9,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 10,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 11,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 12,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 3,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 14,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 15,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 16,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 17,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 18,
    file: "SEKİZGEN OKTOBİN KUTU KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 19,
    file: "MEŞRUBAT KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
  {
    id: 20,
    file: "CAM ŞİŞE TAŞIYICI KUTUSU",
    text: "Neque porro quisquam est qui dolorem ipsum quia dolor..",
    image: "kutu_1",
  },
];

const MakinaData = [
  {
    id: "1",
    header1: "Our Machine Parks",
    detail:
      '"Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box."',
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "2",
    header1: "Subject 2 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "3",
    header1: "Subject 3 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "4",
    header1: "Subject 4 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "5",
    header1: "Subject 5 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "6",
    header1: "Subject 6 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "7",
    header1: "Subject 7 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
  {
    id: "8",
    header1: "Subject 8 Header",
    detail:
      "Mabsan Box started to take shape in a workshop with art and manual labour. The first layer represents the birth of traditional arts and creativity When it took its first breath, it came into existence as a box.",
    header2: "173 cm B+C",
    header3: "Corrugated Cardboard Line",
    photoLink: Makina_Data,
  },
];

const Mabsan_Way = {
  value1: "Valuable Production",
  value2: `
    "At Mabsan, the production cycle starts with trust. With our 36 years of experience, we first analyze sectoral needs and develop the most innovative solutions with our innovative perspective. With our competent staff, we design boxes and parcels that will keep your products safe and highlight your brand. We never compromise on quality during this entire process. Because we know that our valued customers have trusted us for 36 years. "
    `,
  value3: Mabsan_Way_image,
};

const MukavvaData = [
  {
    id: "1",
    header1: "Corrugated Cardboard Types",
    detail:
      "E-wave, which has the smallest wave form, offers an ideal solution for our customers who need thin and light products. It is frequently preferred in packaging, box and carton production.",
    header2: "E Wave",
    header3: "Corrugated Cardboard",
    photoLink: Mukavva_Data,
  },
  {
    id: "2",
    header1: "Corrugated Cardboard Types",
    detail:
      "B-wave, which has a medium-sized waveform, is frequently used for products that require durability. It is preferred in the packaging of electronics, white goods and other industrial products.",
    header2: "B Wave",
    header3: "Corrugated Cardboard",
    photoLink: Mukavva_Data,
  },
  {
    id: "3",
    header1: "Corrugated Cardboard Types",
    detail:
      "C-wave, which has a larger waveform, is used in the packaging of supermarket products, industrial and agricultural products. It stands out with its durability and protection properties.",
    header2: "C Wave",
    header3: "Corrugated Cardboard",
    photoLink: Mukavva_Data,
  },
  {
    id: "4",
    header1: "Corrugated Cardboard Types",
    detail:
      "A-wave, which has the largest waveform, is especially used for packaging heavy and bulky products. It offers high durability.",
    header2: "A Wave",
    header3: "Corrugated Cardboard",
    photoLink: Mukavva_Data,
  },
];

const KagitData = [
  {
    id: "1",
    header1: "Paper Types",
    detail:
      "Kraft paper, which is natural, brown in colour and has high durability, is the most commonly used paper type in corrugated cardboard production. It stands out with its strength, moisture and tear resistance properties.",
    header2: "Kraft ",
    header3: "Paper",
    photoLink: Mukavva_Data,
  },
  {
    id: "2",
    header1: "Paper Types",
    detail:
      "This paper type, which is white in colour and has a flat and smooth surface, is preferred in the production of products that require higher print quality. It is useful in packaging and box designs.",
    header2: "White ",
    header3: "Paper",
    photoLink: Mukavva_Data,
  },
  {
    id: "3",
    header1: "Paper Types",
    detail:
      "Recycled paper, which is an environmentally friendly option, is a raw material that we attach importance to because it saves resources and complies with our sustainability principles.",
    header2: "Recycled ",
    header3: "Paper",
    photoLink: Mukavva_Data,
  },
  {
    id: "4",
    header1: "Paper Types",
    detail:
      "This type of paper, whose surface is reinforced with special coatings, provides high resistance to moisture, oil or water. It is frequently used in food, pharmaceutical and electronic product packaging.",
    header2: "Special Coated ",
    header3: "Paper",
    photoLink: Mukavva_Data,
  },
];

const Diger_Sektorler_Data = [
  {
    id: "1",
    Title: "E-Commerce",
    Text:
      "Speed and trust are key in the e-commerce industry, where sales must continue 24/7 regardless of the conditions. With our e-commerce expertise, you can trust us to provide reliable, innovative and sustainable solutions for your online business and your customers.",
    photoLink: Kutu_1,
  },
  {
    id: "2",
    Title: "Industrial",
    Text:
      "In the industrial market, product safety is paramount. From heavy and bulky products to hazardous materials, it is critical to provide flexible options that can withstand the logistical challenges of industrial products. That's why our corrugated solutions undergo extensive testing to ensure durability and reliability during transport.",
    photoLink: Kutu_2,
  },
  {
    id: "3",
    Title: "Retail",
    Text:
      "The power of packaging in the purchasing decisions of today's consumers is indisputable. Not only design, but also packaging that is safe and takes into account user behaviour makes a big difference in sales. You can rely on our experience with many national and international retail brands.",
    photoLink: Kutu_3,
  },
  {
    id: "4",
    Title: "Cosmetics",
    Text:
      "In the highly competitive cosmetics market, it is becoming difficult for brands to stay in the minds of existing and new consumers. This leads to the need for continuous innovation in visual and texture. As a reliable and creative business partner, we are at your side to help your products stand out.",
    photoLink: Kutu_4,
  },
  {
    id: "5",
    Title: "Fresh Fruit and Vegetables",
    Text:
      "With high volumes of fresh fruit and vegetable products requiring protection against spoilage throughout the supply chain, it is essential to utilise strong and reliable packaging solutions. Our carefully engineered paper-based solutions for each product type are designed, tested and manufactured to protect food products while fulfilling our sustainability promise.",
    photoLink: Kutu_5,
  },
  {
    id: "6",
    Title: "FMCG",
    Text:
      "FMCG packaging and displays are critical tools for influencing consumers at the moment of decision. We utilise our extensive FMCG experience to make your products stand out and maintain efficiency in the supply chain.",
    photoLink: Kutu_6,
  },
  {
    id: "7",
    Title: "Automotive",
    Text:
      "Whether we’re packing small or large, light or heavy components, we use proven scientific methods to deliver fit-for-purpose, sustainable packaging solutions. Our range of products, including friction and corrosion-resistant packaging, are designed to meet the physical demands of your supply chain.",
    photoLink: Kutu_7,
  },
  {
    id: "8",
    Title: "Take-Away",
    Text:
      "From fast-food chains to fine dining restaurants, today's food and beverage sector cares about its environmental impact; prefers paper-based packages instead of plastic. You can trust us to ensure the satisfaction of your customers in your take-away or package services.",
    photoLink: Kutu_8,
  },
];

const Main_Data = {
  SektorItems: SektorItems,
  UretimData: UretimData,
  YolculugumuzData: YolculugumuzData,
  Paragraflar: Paragraflar,
  Cards: Cards,
  YonetimData: YonetimData,
  SurdurData: SurdurData,
  UrunData: UrunData,
  MakinaData: MakinaData,
  Mabsan_Way: Mabsan_Way,
  MukavvaData: MukavvaData,
  KagitData: KagitData,
  Diger_Sektorler_Data: Diger_Sektorler_Data,
  YasalData: YasalData,
  GizlilikData: GizlilikData,
  HizmetPolitikakData: HizmetPolitikakData,
  CerezPolitikakData: CerezPolitikakData,
};

export default Main_Data;
